var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.step === 1
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("h3", [
                  _vm._v(
                    "ปลดล็อคเรื่องเงินให้ชีวิตติดปีกกับแอปสินเชื่อออนไลน์ฟินนิกซ์"
                  )
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(
                    "เพิ่มเงินแสนหมุนสบายให้กับคุณแม่บ้าน BeNeat ไม่ต้องใช้เอกสาร ไม่ต้องค้ำประกัน"
                  )
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "mt-3 text-muted",
                    staticStyle: { "font-size": "85%" }
                  },
                  [
                    _vm._v(
                      "\n          สอบถามข้อมูลผลิตภัณฑ์หรือโครงการเพิ่มเติม กรุณาติดต่อศูนย์บริการลูกค้าบริษัทมันนิกซ์ โทร. 02-329-5956\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "my-3" }, [
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-lg btn-block finnix",
                        attrs: { disabled: _vm.pass === 0 },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.next(2)
                          }
                        }
                      },
                      [_vm._v("ดำเนินการต่อ")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.pass === 0
                    ? _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _vm.reason
                            ? [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(_vm._s(_vm.reason))
                                ])
                              ]
                            : !_vm.professionalId
                            ? [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "เกิดข้อผิดพลาด หากสนใจบริการ กรุณาติดต่อแอดมิน"
                                  )
                                ])
                              ]
                            : [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "เกิดข้อผิดพลาด หากสนใจบริการ กรุณาติดต่อแอดมิน"
                                  )
                                ])
                              ]
                        ],
                        2
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        : _vm.step === 2
        ? [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row pt-4",
                staticStyle: { "background-color": "#eeeeee" }
              },
              [
                _c("div", { staticClass: "col-md-12" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-label", attrs: { for: "tel" } },
                      [
                        _vm._v(
                          "กรอกเบอร์โทรศัพท์ที่ท่านได้ลงทะเบียนไว้กับ BeNeat"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tel,
                            expression: "tel"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "tel",
                          name: "tel",
                          type: "number",
                          placeholder: "เบอร์โทรศัพท์"
                        },
                        domProps: { value: _vm.tel },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.tel = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(6),
                  _vm._v(" "),
                  _vm._m(7),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "panel mb-2",
                      staticStyle: { "background-color": "#fefefe" }
                    },
                    [
                      _c("div", { staticClass: "form-group ml-3 mb-1" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.accept,
                                expression: "accept"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              id: "accept",
                              name: "accept"
                            },
                            domProps: {
                              value: 1,
                              checked: _vm._q(_vm.accept, 1)
                            },
                            on: {
                              change: function($event) {
                                _vm.accept = 1
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "mb-1 mt-2",
                              attrs: { for: "accept" }
                            },
                            [_vm._v("\n                ยินยอม\n              ")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.accept,
                                expression: "accept"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              id: "decline",
                              name: "accept"
                            },
                            domProps: {
                              value: 0,
                              checked: _vm._q(_vm.accept, 0)
                            },
                            on: {
                              change: function($event) {
                                _vm.accept = 0
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticClass: "mb-1", attrs: { for: "decline" } },
                            [
                              _vm._v(
                                "\n                ไม่ยินยอม\n              "
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "my-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-lg btn-block finnix",
                        attrs: { disabled: _vm.accept !== 1 },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.next(3)
                          }
                        }
                      },
                      [_vm._v("ดำเนินการต่อ")]
                    )
                  ])
                ])
              ]
            )
          ]
        : _vm.step === 3
        ? [
            _c("div", { staticClass: "p-3 finnix-bg" }, [
              _c(
                "div",
                {
                  staticClass: "panel p-3",
                  staticStyle: { "background-color": "white" }
                },
                [
                  _vm._v(
                    "\n        ท่านได้ให้ความยินยอมแก่บริษัท บีนีท จำกัด ในการเปิดเผยข้อมูลดังกล่าวให้แก่ บริษัท มันนิกซ์ จำกัด เรียบร้อยแล้ว กรุณาดำเนินการสมัครผ่านแอปพลิเคชันฟินนิกซ์ (FINNIX) ของบริษัท มันนิกซ์ จำกัดต่อไปด้านล่าง เพื่อดาวน์โหลดแอปพลิเคชันฟินนิกซ์ (FINNIX)\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "my-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-block",
                    staticStyle: {
                      color: "white",
                      "background-color": "#F25942"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.download()
                      }
                    }
                  },
                  [_vm._v("ดาวน์โหลดแอปฟินนิกซ์")]
                )
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: "/static/img/finnix01.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3" }, [
      _c("span", { staticStyle: { "font-weight": "500" } }, [
        _vm._v("สินเชื่อนาโนฟินนิกซ์ติดปีก (สินเชื่อนาโนไฟแนนซ์) ดียังไง?")
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "ml-4 mt-2" }, [
        _c("li", [_vm._v("สมัครง่าย รู้ผลไว ทำได้เองในแอป")]),
        _vm._v(" "),
        _c("li", [_vm._v("ให้วงเงินสูงสุด 100,000 บาท")]),
        _vm._v(" "),
        _c("li", [_vm._v("ดอกเบี้ยต่ำเพียง 2.75% ต่อเดือน")]),
        _vm._v(" "),
        _c("li", [_vm._v("อนุมัติปั๊บ รับเงินไวสุดใน 5 นาที")]),
        _vm._v(" "),
        _c("li", [_vm._v("เลือกจ่ายตามใจ ได้เงินไปหมุนต่อทันที")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3 text-danger" }, [
      _c("span", { staticStyle: { "font-weight": "500" } }, [
        _vm._v(
          "พิเศษ! สำหรับคุณแม่บ้าน BeNeat ที่มีประวัติการทำงานดี มีโอกาสได้รับพิจารณาสินเชื่อได้ง่ายขึ้นเพียงมีคุณสมบัติดังต่อไปนี้"
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "ml-4 mt-2" }, [
        _c("li", [
          _vm._v("รับงานผ่านระบบ BeNeat มาต่อเนื่องอย่างต่ำ 3 เดือนขึ้นไป")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "มีประวัติการรับงานคงที่สม่ำเสมอไม่ต่ำกว่า 70 ชม. ต่อเดือนขึ้นไป และต้องได้รับรายได้จาก BeNeat โดยผ่านบัญชีธนาคารที่เป็นชื่อของตนเองเท่านั้น"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "มีความรับผิดชอบสูงและไม่มีประวัติรับงานแล้วไม่ไปให้บริการในระยะเวลา 3 เดือนที่ผ่านมา"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "มีความซื่อสัตย์ ไม่มีพฤติกรรมการดึงลูกค้าออกนอกระบบ หรือประวัติการรับเงินตรงจากลูกค้า"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3" }, [
      _c("div", [
        _c(
          "span",
          { staticClass: "text-muted", staticStyle: { "font-weight": "500" } },
          [_vm._v("หมายเหตุ")]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", { staticClass: "text-muted" }, [
          _vm._v(
            "การพิจารณาและอนุมัติสินเชื่อนั้นเป็นไปตามเกณฑ์การพิจารณาของบริษัท มันนิกซ์ จำกัด โดย BeNeat เป็นเพียงผู้ประสานงานและอำนวยความสะดวกในการขอสินเชื่อเท่านั้น"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: "/static/img/finnix02.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h4", [_vm._v("กรอกข้อมูลเพื่อเข้าร่วมโครงการ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mt-4" }, [
      _c("h4", [
        _vm._v("ความยินยอมในการเปิดเผยข้อมูล"),
        _c("br"),
        _vm._v("ระหว่าง MONIX และ BeNeat")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "font-size": "85%" } }, [
      _c("ol", { staticClass: "ml-3 mt-3" }, [
        _c("li", [
          _vm._v(
            'บริษัท มันนิกซ์ จำกัด ("MONIX") เป็นผู้ให้บริการสินเชื่อส่วนบุคคลภายใต้การกำกับ และผู้ให้บริการสินเชื่อเพื่อการประกอบอาชีพภายใต้การกำกับ ที่ได้รับอนุญาตจากธนาคารแห่งประเทศไทย ผ่านทางแอปพลิเคชันฟินนิกซ์ ("FINNIX") ที่ลูกค้าสามารถยื่นขอสินเชื่อได้ตามกระบวนการที่ระบุในแอปพลิเคชัน'
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            'MONIX และ บริษัท บีนีท จำกัด ("BeNeat") ได้จัดทำโครงการนี้ร่วมกันเพื่อสำรวจความต้องการของลูกค้าของ BeNeat ในผลิตภัณฑ์ประเภทสินเชื่อ และนำข้อมูลที่ได้รับมาพัฒนาผลิตภัณฑ์เพื่อตอบสนองความต้องการของลูกค้าให้ดียิ่งขึ้น'
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            'ในการดำเนินโครงการนี้ BeNeat ("ผู้ควบคุมข้อมูล") จะดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านตามที่ท่านได้กรอกในแบบฟอร์มนี้ และขอความยินยอมจากท่านในการเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่ MONIX ("ผู้รับข้อมูล") ตามรายการข้อมูลที่ระบุในแบบฟอร์มนี้ เพื่อวัตถุประสงค์ในการจัดทำการส่งเสริมการขายและการตลาดร่วมกันระหว่าง MONIX และ BeNeat โดยข้อมูลของท่านจะถูกนำไปใช้เพื่อจัดทำสถิติ วิเคราะห์ช่องทางในการจัดทำการตลาด โฆษณา และพัฒนาผลิตภัณฑ์ที่เกี่ยวข้อง ระหว่าง MONIX และ BeNeat ต่อไป และจะดำเนินการลบหรือทำลายข้อมูลส่วนบุคคลของท่าน เมื่อสิ้นสุดระยะเวลาอันสมควรตามที่ผู้ควบคุมข้อมูลกำหนด'
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "หากมีข้อสงสัยประการใดเกี่ยวกับผลิตภัณฑ์หรือโครงการ กรุณาติดต่อศูนย์บริการลูกค้าบริษัทมันนิกซ์ โทร 02-329-5956"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            'หากท่านไม่ประสงค์ที่จะให้ผู้ควบคุมข้อมูลส่วนบุคคลเปิดเผยข้อมูลดังกล่าว กรุณาเลือก "ไม่ยินยอม" โดยท่านยังคงสามารถดาวน์โหลดแอปพลิเคชันฟินนิกซ์ผ่านทาง Google Play Store หรือ Huawei AppGallery ได้'
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be13dfb6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be13dfb6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/Finnix.vue
// module id = 1656
// module chunks = 0